/**
 * messagesToDag — public API for the v0.2 ChatDAG pipeline.
 *
 * Phase 2: introduced as a slim passthrough to chatDagDataProcessor,
 * so the Canvas import flip could land independently of the engine
 * rewrite.
 *
 * Phase 4 (T4.3): canvas now uses layoutDag (T4.2). The phantom
 * user-marker synthesis band-aid was DELETED in chatDagDataProcessor
 * itself rather than rewriting the entire 340-line emission block
 * here — a safer cutover. The passthrough stays as the public API
 * surface; chatDagDataProcessor remains as the implementation engine.
 *
 * Future arc: a v0.2.x consolidation pass can fold the
 * chatDagDataProcessor.messagesToDag body into this file once the
 * v0.2 pipeline has settled in production.
 */
import type { Message } from '../../../../contexts/ConversationContext';
import type { Node, Edge } from 'reactflow';
import type { DagResponse } from '../../../../types/dag';
import type { ResolvedHillTarget } from '../../../../types/hill';
import type { ArtifactContentEntry } from '../types';

import { messagesToDag as _messagesToDag } from './chatDagDataProcessor';

export { EMPTY_RUNTIME } from './runtimeOverlay';
export type { RuntimeState } from './runtimeOverlay';

export function messagesToDag(
  messages: Message[],
  runtime?: any,
  dag?: DagResponse,
  onTileClick?: (artifactId: string) => void,
  resolveTarget?: (
    personaId: string | undefined,
    spineRootMessageId: string | undefined,
  ) => ResolvedHillTarget | null,
  // Trailmap L2 Drip 3 — canvas-local fetched artifact bodies, keyed by id.
  artifactContent?: ReadonlyMap<string, ArtifactContentEntry>,
): { nodes: Node[]; edges: Edge[] } {
  return _messagesToDag(messages, runtime, dag, onTileClick, resolveTarget, artifactContent);
}
